import { isArray } from 'util';
import { Category } from '../category';
import { parseNumber } from '../../utils/number.utils';
import { CategoryTypeBuilder } from './category-type.builder';

export class CategoryBuilder {
  static fromJson(json) {
    return (json)
      ? new Category(
        json.hash,
        json.name,
        parseNumber(json.materialCount),
        json.print,
        json.outsourcing,
        json.other,
        parseNumber(json.lastUpdate),
        CategoryTypeBuilder.fromJson(json.type)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(CategoryBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/category.builder.ts